import { render, staticRenderFns } from "./downbox.vue?vue&type=template&id=beeb5d7c&scoped=true&"
import script from "./downbox.vue?vue&type=script&lang=js&"
export * from "./downbox.vue?vue&type=script&lang=js&"
import style0 from "./downbox.vue?vue&type=style&index=0&id=beeb5d7c&scoped=%20scoped&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beeb5d7c",
  null
  
)

export default component.exports